
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class RelationshipTypeGrid extends SiteEntityGrid<RelationshipTypeRow, any> {
        protected getColumnsKey() { return 'Data.RelationshipType'; }
        protected getDialogType() { return RelationshipTypeDialog; }
        protected getIdProperty() { return RelationshipTypeRow.idProperty; }
        protected getInsertPermission() { return RelationshipTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return RelationshipTypeRow.localTextPrefix; }
        protected getService() { return RelationshipTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}